/* Home 2609 – Hero
   The slider itself is the theme's Swiper component (data-component="swiper").
   This file only adds what the theme does not do:
   - load one video per slide for the current screen size (767px and below: mobile, 768px and up: desktop)
   - no autoplay when reduced motion is on (the poster stays)
   - the play / pause button on video slides
   - the proof strip under the slider and the arrow / dot color follow the active slide
   - theme editor: re-init on section load, go to a slide when its block is selected */
(function () {
  var MOBILE = window.matchMedia('(max-width: 767.98px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function videosOf(wrap) {
    var all = wrap.querySelectorAll('video[data-src]');
    var pick = null;
    var rest = [];
    for (var i = 0; i < all.length; i++) {
      var size = all[i].getAttribute('data-size');
      var match = size === 'all' || (size === 'sm' && MOBILE.matches) || (size === 'lg' && !MOBILE.matches);
      if (match && !pick) pick = all[i];
      else rest.push(all[i]);
    }
    return { pick: pick, rest: rest };
  }

  function syncVideos(root) {
    var wraps = root.querySelectorAll('[data-h2609-video]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var v = videosOf(wrap);
      for (var j = 0; j < v.rest.length; j++) v.rest[j].pause();
      var shouldPlay = !REDUCED.matches && wrap.getAttribute('data-paused') !== 'true';
      if (v.pick && shouldPlay) {
        if (!v.pick.getAttribute('src')) v.pick.setAttribute('src', v.pick.getAttribute('data-src'));
        var p = v.pick.play();
        if (p && p.catch) p.catch(function () {});
      } else if (v.pick) {
        v.pick.pause();
      }
      wrap.classList.toggle('on', !!(v.pick && shouldPlay));
      wrap.classList.toggle('off', !(v.pick && shouldPlay));
    }
  }

  function bindVideoButtons(root) {
    var btns = root.querySelectorAll('[data-h2609-video] [data-hook="play-pause"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        e.preventDefault();
        var wrap = this.closest('[data-h2609-video]');
        var playing = wrap.classList.contains('on');
        if (playing) {
          wrap.setAttribute('data-paused', 'true');
        } else {
          wrap.removeAttribute('data-paused');
          // a click is an explicit request to play, even under reduced motion
          var v = videosOf(wrap).pick;
          if (v) {
            if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            wrap.classList.add('on');
            wrap.classList.remove('off');
            return;
          }
        }
        syncVideos(root);
      });
    }
  }

  function bindSwiper(root) {
    var el = root.querySelector('.swiper');
    if (!el) return;
    var tries = 0;
    (function wait() {
      if (el.swiper) return hook(el.swiper);
      if (tries++ < 100) setTimeout(wait, 100);
    })();

    function hook(sw) {
      var sets = root.querySelectorAll('[data-h2609-proof] [data-index]');
      function update() {
        var i = sw.realIndex;
        for (var k = 0; k < sets.length; k++) sets[k].hidden = Number(sets[k].getAttribute('data-index')) !== i;
        var slide = sw.slides[sw.activeIndex];
        if (slide && slide.getAttribute('data-controls')) root.style.setProperty('--h2609-controls', slide.getAttribute('data-controls'));
      }
      sw.on('slideChange', update);
      update();
      root.h2609Swiper = sw;
    }
  }

  function init(root) {
    if (!root || root.h2609Ready) return;
    root.h2609Ready = true;
    syncVideos(root);
    bindVideoButtons(root);
    bindSwiper(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-h2609-hero]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function onMediaChange() {
    var roots = document.querySelectorAll('[data-h2609-hero]');
    for (var i = 0; i < roots.length; i++) syncVideos(roots[i]);
  }
  if (MOBILE.addEventListener) {
    MOBILE.addEventListener('change', onMediaChange);
    REDUCED.addEventListener('change', onMediaChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('[data-h2609-hero] .swiper-slide') : null;
    if (!slide) return;
    var root = slide.closest('[data-h2609-hero]');
    var sw = root && root.h2609Swiper;
    if (sw) sw.slideToLoop(Number(slide.getAttribute('data-index')));
  });
})();
